import { forwardRef } from "react";
import type { SyntheticEvent } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import type { AlertColor } from "@mui/material/Alert";

const Alert = forwardRef<HTMLDivElement, AlertProps>(
  function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  },
);

interface Props {
  open: boolean;
  severity: AlertColor;
  message: string;
  handleClose: (event?: Event | SyntheticEvent) => void;
  anchorOriginVertical?: "top" | "bottom";
  anchorOriginHorizontal?: "left" | "center" | "right";
  width?: string;
  top?: string;
  right?: string;
  left?: string | null;
  autoHide?: boolean;
  position?: string | null;
  height?: string | null;
}

const SbuxSnackbars = ({
  open,
  severity,
  message,
  handleClose,
  anchorOriginVertical = "top",
  anchorOriginHorizontal = "right",
  width = "100%",
  top = "12%",
  right = "2%",
  left = null,
  autoHide = true,
  position = null,
  height = null,
}: Props) => {
  if (!open) return null;

  return (
    <Snackbar
      sx={{
        "&.MuiSnackbar-root": {
          top: top,
          right: right,
          left: left ?? undefined,
          position:
            (position as
              | "fixed"
              | "absolute"
              | "relative"
              | "sticky"
              | "static"
              | undefined) ?? undefined,
          height: height ?? undefined,
        },
      }}
      open={open}
      anchorOrigin={{
        vertical: anchorOriginVertical,
        horizontal: anchorOriginHorizontal,
      }}
      autoHideDuration={autoHide && open ? 6000 : null}
      onClose={(event, reason) => {
        if (reason === "clickaway") {
          return;
        }
        handleClose(event);
      }}
    >
      <Alert
        onClose={handleClose}
        severity={severity}
        sx={{ width: width, fontSize: 12 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default SbuxSnackbars;
